import { createResponseSchema } from "@/shared";
import { SmtpSchema } from "../schema/schema";
import { z } from "zod";

const SmtpResponseSchema = z.object({
  smtp: SmtpSchema,
});

export const SmtpResponseDto = createResponseSchema(SmtpResponseSchema);
